import React from "react";
import Layout from "components/Layout";
import { getGlobals } from "lib/getGlobals";
import Meta from "components/Meta";
import Header from "components/Header";
import Link from "next/link";

export default function NotFoundPage({ globals }) {
  return (
    <Layout globals={globals}>
      <Meta
        title="Erreur 404"
        description="La page que vous recherchez n'a pas été trouvée."
      />
      <Header crumbs={[]} title="Erreur 404" />

      <section className="pt-4" style={{ paddingBottom: "17%" }}>
        <div className="relative container mx-auto px-4 lg:max-w-screen-lg">
          <div className="prose">
            <div className="mb-6">
              <p className="inline-block">
                La page que vous recherchez n&apos;a pas été trouvée.
              </p>
            </div>
            <Link href="/" passHref>
              <a className="button button--white">Retour à l&apos;accueil</a>
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}

export async function getStaticProps(context) {
  return {
    props: {
      globals: await getGlobals(context),
    },
    revalidate: 30,
  };
}
